// SidebarLayout.jsx
import React, { useEffect, useState } from 'react';

// MUI Icons
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import { useLocation, useNavigate } from 'react-router';
import ProjectAdmin from '../Admin/Project/ProjectAdmin';
import HomeAdmin from '../Admin/Home/HomeAdmin';
import ArticleAdmin from '../Admin/Article/ArticleAdmin';
import CampaignAdmin from '../Admin/Campaign/CampaignAdmin';
import OrgAdmin from '../Admin/Org/OrgAdmin';
import StaffAdmin from '../Admin/Staff/StaffAdmin';
import ResourceAdmin from '../Admin/Resource/ResourceAdmin';






const SidebarLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab,setActiveTab]=useState("home")

  const navItems = [
    { label: 'Home', icon: <HomeOutlinedIcon />, path: '/staff/home/',tab:'home' },
    { label: 'Projects', icon: <WorkOutlineOutlinedIcon />, path: '/staff/projects/',tab:'projects-view'  },
    { label: 'Articles', icon: <TaskAltOutlinedIcon />, path: '/staff/articles/',tab:'articles-view'  },
    { label: 'Campaigns', icon: <ChatBubbleOutlineOutlinedIcon />, path: '/staff/campaigns/',tab:'campaigns-view'  },
    { label: 'Organisation', icon: <ExploreOutlinedIcon />, path: '/staff/organisation/',tab:'org-view'  },
    { label: 'Staff Profile', icon: <PersonOutlinedIcon />, path: '/staff/profile/',tab:'staff-view' },
    { label: 'Resources', icon: <AssignmentTwoToneIcon />, path: '/staff/resources/',tab:'resource-view' },
    { label: 'On-Demand', icon: <ElectricBoltOutlinedIcon />, path: '/staff/on-demand/', hasDot: true, },
  ];

  useEffect(()=>{
    // console.log(location)
    if((location?.pathname==="/staff/projects/" && activeTab !== "projects-view") || location?.pathname.includes("/staff/projects")){
      setActiveTab("projects-view")
    }else if((location?.pathname==="/staff/campaigns/" && activeTab !== "campaigns-view") || location?.pathname.includes("/staff/campaigns")){
      setActiveTab("campaigns-view")
    }else if((location?.pathname==="/staff/organisation/" && activeTab !== "org-view") || location?.pathname.includes("/staff/organisation")){
      setActiveTab("org-view")
    }else if((location?.pathname==="/staff/profile/" && activeTab !== "staff-view") || location?.pathname.includes("/staff/profile")){
      setActiveTab("staff-view")
    }else if((location?.pathname==="/staff/projects/detail/" && activeTab !== "projects-view") || location?.pathname.includes("/staff/projects")){
      setActiveTab("projects-view")
    }else if((location?.pathname.includes("/staff/project/detail/") && activeTab !== "projects-view")){
      setActiveTab("projects-view")
    }else if((location?.pathname==="/staff/articles/" && activeTab !== "articles-view") || location?.pathname.includes("/staff/articles")){
      setActiveTab("articles-view")
    }
    else if((location?.pathname.includes("/staff/article/detail/") && activeTab !== "articles-view")){
      setActiveTab("articles-view")
    }else if((location?.pathname==="/staff/resources/" && activeTab !== "resource-view") || location?.pathname.includes("/staff/resources")){
      setActiveTab("resource-view")
    }
    else if((location?.pathname.includes("/staff/resources/detail/") && activeTab !== "resources-view")){
      setActiveTab("resource-view")
    }
    else if((location?.pathname.includes("/staff/home/") && activeTab !== "home")){
      setActiveTab("home")
    }
  },[location])

  useEffect(()=>{
    if(location?.state?.redirect==='home'){
      setActiveTab("home")
    }
  },[location?.state])

  const views = {
    "projects-view":<ProjectAdmin/>,
    "home":<HomeAdmin/>,
    "articles-view":<ArticleAdmin/>,
    "campaigns-view":<CampaignAdmin/>,
    "org-view":<OrgAdmin/>,
    "staff-view":<StaffAdmin/>,
    "resource-view":<ResourceAdmin/>,
  }

  return (
    <div className="side-container">
    <div className="sidebar">
      <div className="side-nav-group">
       
          {
          navItems.map(({ label, icon, path, hasDot,tab }) => {
            const isActive = location.pathname === path;
            return (

              <div
              key={path}
              className={`side-nav-item ${isActive ? 'active' : ''}`}
              onClick={() =>{
                setActiveTab(tab)
                navigate(path)

              }}
              >
              <div className={hasDot ? 'icon-badge-wrapper' : ''}>
                <span className="icon">{icon}</span>
                {hasDot && <span className="badge-dot" />}
              </div>
              <span className="label">{label}</span>
            </div>
            )
          }
        )}

         </div> 

        
    </div>
    <div className="main-content">
        {/* Placeholder for main page */}

        {
        views[activeTab]||<HomeAdmin/>
        }
        
        </div>
</div>
  )
}

export default SidebarLayout;